import { BehaviorSubject } from "rxjs";
import { encrypt, decrypt } from "./SecureStorage";

class PersistStorage {
  keyName;
  observer;

  constructor(keyName: string, observer: BehaviorSubject<any>) {
    this.keyName = keyName;
    this.observer = observer;
  }

  init = () => {
    // 1. Try reading from sessionStorage (secure location)
    let lastDataString = sessionStorage.getItem(this.keyName);

    if (lastDataString) {
      const decrypted = decrypt(lastDataString);
      if (decrypted) {
        try {
          this.observer.next(JSON.parse(decrypted));
        } catch (e) {
          console.error("PersistStorage: Failed to parse decrypted state:", e);
          sessionStorage.removeItem(this.keyName);
        }
      } else {
        // If decryption fails (e.g. data corrupted or tampered), reset/clear it
        sessionStorage.removeItem(this.keyName);
      }
    } else {
      // 2. Fallback: Migrate from legacy localStorage if exists
      const oldData = localStorage.getItem(this.keyName);
      if (oldData) {
        try {
          const parsed = JSON.parse(oldData);
          this.observer.next(parsed);
          const encrypted = encrypt(oldData);
          if (encrypted) {
            sessionStorage.setItem(this.keyName, encrypted);
          }
        } catch (e) {
          console.error("PersistStorage: Failed to migrate legacy state:", e);
        } finally {
          localStorage.removeItem(this.keyName);
        }
      }
    }

    // Subscribe to state changes and save encrypted value to sessionStorage
    this.observer.subscribe((next) => {
      const stringified = JSON.stringify(next);
      const encrypted = encrypt(stringified);
      if (encrypted) {
        sessionStorage.setItem(this.keyName, encrypted);
      }
    });
  };
}

export default PersistStorage;
